import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import Layout from "../components/Layout";
import FAQChat from "../components/FAQChat";

export default function FAQ() {
  const { t } = useTranslation();

  return (
    <Layout ribbon>
      <Helmet>
        <title>{t("nav.faq")} — Velcor Energy</title>
      </Helmet>

      <FAQChat />
    </Layout>
  );
}
